import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-contracts',
  templateUrl: './add-contracts.component.html',
  styleUrls: ['./add-contracts.component.scss']
})
export class AddContractsComponent implements OnInit {

      public pages  : any
  public tempData = [];
  public totalItems = 0;


formData: any = {
  user_id: '',
  contract_type_id: '',
  duration_months: '',
  investment_amount: '',
  investment_rate: '',
  investment_rate_max:'',
    start_date: '',
  pdf: null 
  // profit_amount: ''
}; 
  InvestorsId: any;
 
  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,
    public _translateService: TranslateService
  ) {}

    ngOnInit(): void {
     this.getTags();
     this. getInvestorsId(); 

    }
 
    // Handle PDF selection
onPdfSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.formData.pdf = event.target.files[0];
  }
}

getTags() {
  this.apisService.contractsType().subscribe({
    next: (response: any) => {
      this.pages = response.data || [];
      this.totalItems = this.pages.length;
      console.log('pages:', this.pages);
    },
    error: (error: any) => {
      console.error('Error fetching contract types:', error);
    }
  });
}

  onFileSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.formData.image = event.target.files[0];
  }
}
    cancel(): void {
      this.router.navigate(['/contracts']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }
 getInvestorsId(){ 
  this.apisService.investors().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
      this.InvestorsId = response.data;  

     
      console.log("InvestorsId:", this.InvestorsId);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }

    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  const form = new FormData();

  form.append('user_id', this.formData.user_id);
  form.append('contract_type_id', this.formData.contract_type_id);
  form.append('duration_months', this.formData.duration_months);
  form.append('investment_amount', this.formData.investment_amount);
  form.append('investment_rate', this.formData.investment_rate);
  form.append('investment_rate_max', this.formData.investment_rate_max);
    form.append('start_date', this.formData.start_date);

    // Append PDF if exists
  if (this.formData.pdf) {
    form.append('pdf', this.formData.pdf);
  }


  this.apisService.addContracts(form).subscribe({
    next: (response: any) => {
      console.log('Added successfully:', response);
      this.toastr.success(this._translateService.instant('MENU.DASHBOARD.contract_added_successfully'));
      this.router.navigate(['/contracts']);
    },
    error: (error: any) => {
      console.error('Error adding contract:', error);

      if (error.error?.errors) {
        const errors = error.error.errors;
        // Show all validation errors from backend
        Object.keys(errors).forEach((key) => {
          this.toastr.error(errors[key][0]);
        });
      } else {
        this.toastr.error(this._translateService.instant('MENU.DASHBOARD.something_went_wrong'));
      }
    },
  });
}


}